module.exports = __webpack_public_path__ + "static/img/美国.49ddc67c.jpg";